<template>
    <div class="email-preview-panel">
        <div class="preview-header">
            <h4>Aperçu</h4>
            <v-btn-toggle v-model="previewMode" mandatory>
                <v-btn small value="desktop">
                    <v-icon>mdi-desktop</v-icon>
                </v-btn>
                <v-btn small value="tablet">
                    <v-icon>mdi-tablet</v-icon>
                </v-btn>
                <v-btn small value="mobile">
                    <v-icon>mdi-cellphone</v-icon>
                </v-btn>
            </v-btn-toggle>
        </div>

        <div class="preview-container" :class="previewMode">
            <div class="email-preview-content" v-html="renderedHtml"></div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'EmailPreviewPanel',
    props: {
        blocks: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            previewMode: 'desktop'
        }
    },
    computed: {
        renderedHtml() {
            let html = `
                <div style="max-width: 600px; margin: 0 auto; font-family: Arial, sans-serif; background: white;">
                    <div style="padding: 20px;">
            `

            this.blocks.forEach(block => {
                html += this.renderBlock(block)
            })

            html += `
                    </div>
                </div>
            `

            return html
        }
    },
    methods: {
        renderBlock(block) {
            switch (block.type) {
                case 'text':
                    return `<div style="${this.getStylesString(block.styles)}">${block.content}</div>`

                case 'image':
                    return `
                        <div style="text-align: center; margin: 10px 0;">
                            <img src="${block.src}" alt="${block.alt}" style="${this.getStylesString(block.styles)}" />
                        </div>
                    `

                case 'button':
                    return `
                        <div style="text-align: center; margin: 20px 0;">
                            <a href="${block.url}" style="${this.getStylesString(block.styles)} text-decoration: none; display: inline-block;">
                                ${block.text}
                            </a>
                        </div>
                    `

                case 'separator':
                    return `
                        <div style="margin: ${block.styles?.margin || '20px 0'}; height: ${block.styles?.height || '1px'}; background: ${block.styles?.backgroundColor || '#e0e0e0'};"></div>
                    `

                default:
                    return ''
            }
        },

        getStylesString(styles) {
            if (!styles) return ''
            return Object.entries(styles)
                .map(([key, value]) => `${key}: ${value}`)
                .join('; ')
        }
    }
}
</script>

<style lang="scss" scoped>
.email-preview-panel {
    background: #f5f5f5;
    padding: 16px;
    border-radius: 8px;
    height: 100%;
    display: flex;
    flex-direction: column;
}

.preview-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;

    h4 {
        margin: 0;
        font-size: 14px;
        font-weight: 500;
    }
}

.preview-container {
    flex: 1;
    background: white;
    border-radius: 8px;
    overflow: auto;
    padding: 20px;

    &.desktop {
        max-width: 600px;
    }

    &.tablet {
        max-width: 400px;
    }

    &.mobile {
        max-width: 300px;
    }
}

.email-preview-content {

    // Styles pour l'aperçu
    img {
        max-width: 100%;
        height: auto;
        border-radius: 4px;
    }

    a {
        text-decoration: none;
        transition: opacity 0.2s;

        &:hover {
            opacity: 0.8;
        }
    }

    p {
        margin: 0 0 16px 0;
        line-height: 1.6;

        &:last-child {
            margin-bottom: 0;
        }
    }

    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
        margin: 0 0 16px 0;
        font-weight: bold;
    }

    ul,
    ol {
        margin: 0 0 16px 0;
        padding-left: 20px;
    }

    li {
        margin-bottom: 8px;
    }
}
</style>
